import React from 'react';
import BuildIcon from 'housecall-ui/dist/IconsAndImages/Icons/Build';
import EmailIcon from 'housecall-ui/dist/IconsAndImages/Icons/Email';
import CallSplitIcon from 'housecall-ui/dist/IconsAndImages/Icons/CallSplit';
import MarkunreadMailboxIcon from 'housecall-ui/dist/IconsAndImages/Icons/MarkUnreadMailbox';
import ChatIcon from 'housecall-ui/dist/IconsAndImages/Icons/Chat';
import SmsIcon from 'housecall-ui/dist/IconsAndImages/Icons/SMS';
import AssignmentIndIcon from 'housecall-ui/dist/IconsAndImages/Icons/AssignmentInd';
import UpdateIcon from 'housecall-ui/dist/IconsAndImages/Icons/Update';
import EditLocationIcon from 'housecall-ui/dist/IconsAndImages/Icons/EditLocation';
import AttachFileIcon from 'housecall-ui/dist/IconsAndImages/Icons/AttachFile';
import EventBusyIcon from 'housecall-ui/dist/IconsAndImages/Icons/EventBusy';
import StopIcon from 'housecall-ui/dist/IconsAndImages/Icons/Stop';
import SignatureIcon from 'housecall-ui/dist/IconsAndImages/Icons/Signature';
import ListIcon from 'housecall-ui/dist/IconsAndImages/Icons/List';
import AssignmentIcon from 'housecall-ui/dist/IconsAndImages/Icons/Assignment';
import NoteIcon from 'housecall-ui/dist/IconsAndImages/Icons/Note';
import ListNumberedIcon from 'housecall-ui/dist/IconsAndImages/Icons/ListNumbered';
import MonetizationOnIcon from 'housecall-ui/dist/IconsAndImages/Icons/MonetizationOn';
import MoneyOffIcon from 'housecall-ui/dist/IconsAndImages/Icons/MoneyOff';
import EventIcon from 'housecall-ui/dist/IconsAndImages/Icons/Event';
import PlayArrowIcon from 'housecall-ui/dist/IconsAndImages/Icons/PlayArrow';
import UndoIcon from 'housecall-ui/dist/IconsAndImages/Icons/Undo';
import GroupAddIcon from 'housecall-ui/dist/IconsAndImages/Icons/GroupAdd';
import ErrorIcon from 'housecall-ui/dist/IconsAndImages/Icons/Error';
import AttachMoneyIcon from 'housecall-ui/dist/IconsAndImages/Icons/AttachMoney';
import CheckIcon from 'housecall-ui/dist/IconsAndImages/Icons/Check';
import CloseIcon from 'housecall-ui/dist/IconsAndImages/Icons/Close';
import QuickbooksAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/QuickbooksAppIcon';
import OMWIcon from 'housecall-ui/dist/IconsAndImages/Icons/OMW';
import ChecklistsIcon from 'housecall-ui/dist/IconsAndImages/Icons/Checklists';
import AddShoppingCart from 'housecall-ui/dist/IconsAndImages/Icons/AddShoppingCart';
import PrintIcon from 'housecall-ui/dist/IconsAndImages/Icons/Print';
import CreditCardIcon from 'housecall-ui/dist/IconsAndImages/Icons/Payment';
import CalendarTodayIcon from 'housecall-ui/dist/IconsAndImages/Icons/CalendarToday';
import SettingsIcon from 'housecall-ui/dist/IconsAndImages/Icons/Settings';
import EstimateIcon from 'housecall-ui/dist/IconsAndImages/Icons/Estimate';
import Person from 'housecall-ui/dist/IconsAndImages/Icons/Person';

export const NORMAL = 'normal';
export const UNIMPORTANT = 'unimportant';
export const GETTING_PAID = 'getting-paid';
export const ALERT = 'alert';

const kindToIconAndClassMapping = {
  'automated notification email sent': { className: UNIMPORTANT, icon: <EmailIcon /> },
  'job converted to estimate': { className: UNIMPORTANT, icon: <CallSplitIcon /> },
  'job created from estimate': { className: NORMAL, icon: <CallSplitIcon /> },
  'manual notification email sent': { className: UNIMPORTANT, icon: <EmailIcon /> },
  'marketing email': { className: UNIMPORTANT, icon: <EmailIcon /> },
  'marketing postcard': { className: UNIMPORTANT, icon: <MarkunreadMailboxIcon /> },
  'notification push sent': { className: UNIMPORTANT, icon: <ChatIcon /> },
  'notification sms sent': { className: UNIMPORTANT, icon: <SmsIcon /> },
  'recurrence dispatched': { className: NORMAL, icon: <AssignmentIndIcon /> },
  'recurrence scheduled': { className: NORMAL, icon: <UpdateIcon /> },
  'request address changed': { className: NORMAL, icon: <EditLocationIcon /> },
  'request attachment added': { className: UNIMPORTANT, icon: <AttachFileIcon /> },
  'request attachments added': { className: UNIMPORTANT, icon: <AttachFileIcon /> },
  'request attachment deleted': { className: UNIMPORTANT, icon: <AttachFileIcon /> },
  'request cancelled': { className: NORMAL, icon: <EventBusyIcon /> },
  'request deleted': { className: NORMAL, icon: <EventBusyIcon /> },
  'request completed': { className: NORMAL, icon: <StopIcon /> },
  'request created': { className: NORMAL, icon: <BuildIcon /> },
  'request signoff': { className: UNIMPORTANT, icon: <SignatureIcon /> },
  'request dispatched': { className: NORMAL, icon: <AssignmentIndIcon /> },
  'request imported from quickbooks': { className: UNIMPORTANT, icon: <QuickbooksAppIcon /> },
  'request line items updated': { className: NORMAL, icon: <ListIcon /> },
  'request message from pro changed': { className: UNIMPORTANT, icon: <AssignmentIcon /> },
  'request notes updated': { className: UNIMPORTANT, icon: <NoteIcon /> },
  'request number changed': { className: UNIMPORTANT, icon: <ListNumberedIcon /> },
  'request payment charged': { className: GETTING_PAID, icon: <MonetizationOnIcon /> },
  'payment moved to job': { className: NORMAL, icon: <MonetizationOnIcon /> },
  'payment moved from job': { className: NORMAL, icon: <MonetizationOnIcon /> },
  'request payment deleted': { className: ALERT, icon: <MoneyOffIcon /> },
  'request payment refunded': { className: ALERT, icon: <MoneyOffIcon /> },
  'request tip amount updated': { className: NORMAL, icon: <MonetizationOnIcon /> },
  'request scheduled': { className: NORMAL, icon: <EventIcon /> },
  'request started': { className: NORMAL, icon: <OMWIcon /> },
  'request tax toggled': { className: UNIMPORTANT, icon: <ListIcon /> },
  'request time tracking ended': { className: UNIMPORTANT, icon: <StopIcon /> },
  'request time tracking started': { className: UNIMPORTANT, icon: <PlayArrowIcon /> },
  'request time tracking undo': { className: UNIMPORTANT, icon: <UndoIcon /> },
  'request unfinished': { className: UNIMPORTANT, icon: <UndoIcon /> },
  'request unscheduled': { className: NORMAL, icon: <EventBusyIcon /> },
  'request unstarted': { className: UNIMPORTANT, icon: <UndoIcon /> },
  'ach settlement failed': { className: ALERT, icon: <MonetizationOnIcon /> },
  'mobile check deposit failed': { className: ALERT, icon: <MonetizationOnIcon /> },
  'mobile check deposit reversed': { className: ALERT, icon: <MonetizationOnIcon /> },
  'undo estimate approval or decline': { className: UNIMPORTANT, icon: <UndoIcon /> },
  'contacts imported': { className: NORMAL, icon: <BuildIcon /> },
  'customer approves estimate': { className: NORMAL, icon: <EmailIcon /> },
  'customer declines estimate': { className: NORMAL, icon: <EmailIcon /> },
  'customer books job': { className: NORMAL, icon: <EmailIcon /> },
  'price list import': { className: NORMAL, icon: <EmailIcon /> },
  'organization charge success': { className: GETTING_PAID, icon: <MonetizationOnIcon /> },
  'in app subscription charge failed': { className: ALERT, icon: <ErrorIcon /> },
  'in app subscription charge success': { className: GETTING_PAID, icon: <MonetizationOnIcon /> },
  'organization charge pro refund': { className: ALERT, icon: <MoneyOffIcon /> },
  'organization charge failure': { className: ALERT, icon: <MoneyOffIcon /> },
  'organization charge credit redeem': { className: NORMAL, icon: <MoneyOffIcon /> },
  'Deposit created': { className: UNIMPORTANT, icon: <BuildIcon /> },
  'Deposit edited': { className: UNIMPORTANT, icon: <UpdateIcon /> },
  'Deposit removed': { className: UNIMPORTANT, icon: <MoneyOffIcon /> },
  'customer service agreement created': { className: NORMAL, icon: <GroupAddIcon /> },
  'customer service agreement accepted': { className: NORMAL, icon: <GroupAddIcon /> },
  'customer service agreement restored': { className: NORMAL, icon: <GroupAddIcon /> },
  'customer service agreement renewal created': { className: NORMAL, icon: <GroupAddIcon /> },
  'customer service agreement renewal accepted': { className: NORMAL, icon: <GroupAddIcon /> },
  'customer service agreement created email sent': { className: NORMAL, icon: <EmailIcon /> },
  'customer service agreement accepted email sent': { className: NORMAL, icon: <EmailIcon /> },
  'customer service agreement renewal email sent': { className: NORMAL, icon: <EmailIcon /> },
  'customer service agreement cancelled email sent': { className: NORMAL, icon: <EmailIcon /> },
  'customer service agreement payment failure email sent': { className: NORMAL, icon: <EmailIcon /> },
  'customer service agreement payment success': { className: GETTING_PAID, icon: <AttachMoneyIcon /> },
  'customer service agreement payment failure': { className: ALERT, icon: <ErrorIcon /> },
  'customer service agreement printed': { className: NORMAL, icon: <PrintIcon /> },
  'customer service agreement credit card added': { className: NORMAL, icon: <CreditCardIcon /> },
  'customer service agreement credit card updated': { className: NORMAL, icon: <CreditCardIcon /> },
  'customer service agreement discount updated': { className: NORMAL, icon: <SignatureIcon /> },
  'customer service agreement discount removed': { className: NORMAL, icon: <SignatureIcon /> },
  'customer invoice payment refunded': { className: ALERT, icon: <MoneyOffIcon /> },
  'customer invoice payment deleted': { className: ALERT, icon: <MoneyOffIcon /> },
  'customer invoice marked as paid': { className: GETTING_PAID, icon: <AttachMoneyIcon /> },
  'customer invoice paid by cash check other': { className: GETTING_PAID, icon: <AttachMoneyIcon /> },
  'customer invoice paid by card success': { className: GETTING_PAID, icon: <AttachMoneyIcon /> },
  'customer invoice paid by card failure': { className: ALERT, icon: <MoneyOffIcon /> },
  'proposal sent': { className: NORMAL, icon: <EmailIcon /> },
  'loan application authorized': { classname: NORMAL, icon: <CheckIcon /> },
  'loan application declined': { classname: ALERT, icon: <CloseIcon /> },
  'loan application canceled loan': { className: ALERT, icon: <CloseIcon /> },
  'loan application canceled payment': { className: ALERT, icon: <MoneyOffIcon /> },
  'loan application refunded payment': { className: ALERT, icon: <MoneyOffIcon /> },
  'checklist created': { classname: NORMAL, icon: <ChecklistsIcon /> },
  'checklist deleted': { classname: NORMAL, icon: <ChecklistsIcon /> },
  'checklist completed': { classname: NORMAL, icon: <ChecklistsIcon /> },
  'purchase order created': { classname: NORMAL, icon: <AddShoppingCart /> },
  'purchase order submitted': { classname: NORMAL, icon: <AddShoppingCart /> },
  'draft purchase order removed': { classname: NORMAL, icon: <AddShoppingCart /> },
  plan_change: { classname: NORMAL, icon: <EstimateIcon color="secondary" /> },
  downgrade: { classname: NORMAL, icon: <EstimateIcon color="secondary" /> },
  credit_create: { classname: NORMAL, icon: <MonetizationOnIcon /> },
  credit_remove: { classname: NORMAL, icon: <MonetizationOnIcon /> },
  credit_redeem: { classname: NORMAL, icon: <MonetizationOnIcon /> },
  'billing event update upsell features': { classname: NORMAL, icon: <EstimateIcon color="secondary" /> },
  person: { classname: NORMAL, icon: <Person color="secondary" /> },
};

export function determineIconAndClassName(kind) {
  return kindToIconAndClassMapping[kind] || { className: NORMAL, icon: <SettingsIcon color="secondary" /> };
}
